import angular from 'angular';

import { AfastadosIndexController } from './index/afastados.index.controller';

import { AfastadosListRouting } from './afastados.routes';

import { AfastadosService } from './afastados.service';

export const AfastadosModule = angular.module('AfastadosModule', ['ui.router.state', ])
    .controller('AfastadosIndexController', AfastadosIndexController )
    .service('AfastadosService', AfastadosService)
    .config(AfastadosListRouting)
    .name;
